import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { MessageService } from '../message.service';
import { IRoughcheck } from '../roughcheck';
import { RoughcheckService } from '../roughcheck.service';
import { SessionSetService } from '../session-set.service';

/**
 * RoughcheckFormComponent to start or change a Roughcheck
 */
@Component({
  selector: 'app-roughcheck-form',
  templateUrl: './roughcheck-form.component.html',
})
export class RoughcheckFormComponent implements OnInit {

  private RRef = '';
  private ARef = '';

  roughcheckForm = this.fb.group({
    ref: ['', [Validators.required, Validators.minLength(4)] ],
    pin: '',
  });

  constructor(
    private fb: FormBuilder,
    private service: RoughcheckService,
    private message: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private sessionset: SessionSetService,
    private title: Title,
  ) { }

  /**
   * If the Roughcheck is pin protected
   * Advise the user accordingly
   */
  ngOnInit() {
    if (this.service.getPin()) {
      this.message.add(
        'Please enter the PIN for this Roughcheck',
        'info'
      );
    }
    if (this.service.getARef() && this.service.getRRef()) {
      this.roughcheckForm.get('ref').setValue(
        this.service.getRRef() + '/' + this.service.getARef()
      );
    } else if (this.service.getRRef()) {
      this.roughcheckForm.get('ref').setValue(this.service.getRRef());
    }
    this.title.setTitle( 'Start a Roughcheck assessment' );
  }

  /**
   * Navigate to the Roughcheck
   * TODO
   * Check if this is an existing assessment
   */
  private goRoughcheck() {
    if (this.ARef) {
      this.router.navigate(['/a', this.RRef, this.ARef ]);
    } else {
      this.router.navigate(['/a', this.RRef ]);
    }
  }

  /**
   * Submit pin if supplied,
   * then navigate to the Roughcheck
   * TODO
   * check for aref
   */
  onSubmit() {
    // Clear existing messages
    this.message.clear();
    // Split reference into rref and aref
    const ref = this.roughcheckForm.get('ref').value;
    this.RRef = ref.split('/')[0];
    if (ref.split('/').length > 0) {
      this.ARef = ref.split('/')[1];
    }
    if (this.roughcheckForm.get('pin').value) {
      // Set the pin on the server
      this.sessionset.setSessionKey(
        this.RRef,
        this.ARef,
        'pin',
        this.roughcheckForm.get('pin').value)
      .subscribe(
        response => {
          // After the pin has been set, try the Roughcheck assessment
          this.goRoughcheck();
        }
      );
    } else {
      // Go to the Roughcheck
      this.goRoughcheck();
    }
  }

  /**
   * Go to the Roughcheck home page
   */
  onGoBack() {
    this.router.navigate(['/home']);
  }
}
